import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, IconButton, Tooltip, Grid, Button } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import * as TableFilterActions from 'main/components/tableFilter/store/actions';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import InfoIcon from '@material-ui/icons/Info';
import TableCellTooltip from '../../components/TableCellTooltip';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers';
import PageHeader from 'main/components/PageHeader';
import TableFilter from 'main/components/tableFilter/TableFilter';

const styles = theme => ({
    layoutRoot: {},
});

class CourseList extends Component {

    constructor(props) {
        super(props);
        this.props.getCourseList(props.auth.user.data.auth_id, 'list');
    }

    componentWillUnmount = () => {
        this.props.setTableFilter(this.props.auth.user.data.auth_id, 'CourseList', this.props.filterList.filterColumns);
        this.props.clearFilterStore();
        // this.props.updateCourseListLoaded(false)
    }

    checkLockPermission = (row) => {
        const auth_id = this.props.auth.user.data.auth_id;
        const role = this.props.auth.user.role;
        if (row.IsLocked === 0) {
            return true
        }
        else {
            if (role === 'dev' || role === 'admin' || role === 'company') {
                return true
            }
            else if (role === 'instructor' && row.LockedByAuthID === auth_id) {
                return true
            }
        }
        return false
    }

    editAllow = (row) => {
        if (this.checkLockPermission(row)) {
            let tooltipContent = 'Edit';
            if (row.IsLocked === 1) {
                tooltipContent = <React.Fragment><div>Edit</div><div>(Locked)</div></React.Fragment>
            }
            return (
                <Tooltip title={tooltipContent}>
                    <IconButton
                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                        onClick={(ev) => {
                            ev.stopPropagation();
                            this.handleRowClick('edit', row.course_id);
                        }}
                    >
                        <Icon>border_color</Icon>
                    </IconButton>
                </Tooltip>
            )
        }
        else {
            return (
                <Tooltip title="This course is locked">
                    <Icon style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }} >lock</Icon>
                </Tooltip>
            )
        }

    }

    handleRowClick(page_type, course_id) {
        this.props.history.push(`/course/${page_type}/${course_id}`);
    }

    getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
            if (rowInfo.original.Active === 0) {
                return {
                    style: {
                        background: '#a85e59'
                    } 
                }
            }
        }
        return {};
    }

    checkFilterValueSaved = (column) => {
        const { table_filter } = this.props
        if (!table_filter['CourseList']) {
            return false
        }
        // if (table_filter['CourseList'].find(col => col.id === column.column_id))
        if (!table_filter['CourseList'].find(col => col.id === column)) {
            return false
        }

        else {
            return table_filter['CourseList'].find(col => col.id === column).value.filterValue
        }
    }

    render() {
        const { classes, courseList, table_sort, table_filter, table_page_size, is_loaded, filterList } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded || !this.props.courseListLoadedAfterSave || !this.props.listLoaded) return <React.Fragment>Loading...</React.Fragment>;
        const columns = [
            {
                Header: "Course Name",
                accessor: "CourseName",
            },
            {
                Header: "Course Description",
                accessor: "CourseDescription",
                Cell: row => (
                    <TableCellTooltip
                        item={row.original.CourseDescription}
                        chars={20}
                    />
                )
            },
            {
                Header: "Unscheduled",
                id: "Unscheduled",
                accessor: a => a.Unscheduled === 1 ? <Icon style={{ marginLeft: 'auto', marginRight: 'auto' }}>check</Icon> : null,
                maxWidth: 100,
            },
            {
                Header: "Actions",
                maxWidth: 100,
                Cell: row => (
                    <div className="flex items-center">
                        <Tooltip title="Detail">
                            <IconButton
                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.handleRowClick('detail', row.original.course_id);
                                }}
                            >
                                <Icon>library_books</Icon>
                            </IconButton>
                        </Tooltip>

                        {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "course", "edit") ? null :
                            this.editAllow(row.original)
                        }
                    </div>
                )
            }
        ]

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <PageHeader
                        component_type={"course"}
                        view_type={"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name={"assignment"}
                            view_type={"list"}
                            button_list={[
                                {
                                    display: "Wizard",
                                    type: "create",
                                    color: "primary",
                                    onClick: () => this.props.history.push("/builder/course")
                                },
                                {
                                    display: "Add",
                                    type: "create",
                                    color: "primary",
                                    onClick: () => this.props.history.push("/course/create"),
                                }
                            ]}
                        />
                    </div>
                }
                content={
                    <Grid container style={{ height: '100%' }}>
                        <Grid item xs={9}>
                            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                                <ReactTable

                                    style={{ position: 'absolute' }}
                                    // style={{ overflowY: 'scroll', maxHeight: '100%' }}
                                    columns={columns}
                                    // data={courseList}
                                    data={this.props.filterList.filteredDataList}

                                    defaultPageSize={25}
                                    pageSize={table_page_size[table_name]}
                                    className="-striped -highlight"
                                    noDataText="No Courses Found"
                                    defaultSorted={table_sort[table_name]}
                                    onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                                    filterable={false}
                                    onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                                    getTrProps={this.getTrProps}
                                />
                            </div>

                        </Grid>
                        <Grid item xs={3} style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                                <TableFilter
                                    componentName={'CourseList'}
                                    defaultList={courseList}
                                    preloadValues={table_filter['CourseList'] ? true : false}
                                    columns={[
                                        {
                                            columnName: 'Course Name',
                                            column_id: 'CourseName',
                                            columnType: 'string',
                                            filterType: 'string_contains',
                                            value: this.checkFilterValueSaved('CourseName') || '',
                                            active: this.checkFilterValueSaved('CourseName') ? true : false
                                        },
                                        {
                                            columnName: 'Course Description',
                                            column_id: 'CourseDescription',
                                            columnType: 'string',
                                            filterType: 'string_contains',
                                            value: this.checkFilterValueSaved('CourseDescription') || '',
                                            active: this.checkFilterValueSaved('CourseDescription') ? true : false
                                        },
                                        {
                                            columnName: 'Active',
                                            column_id: 'Active',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            value: this.checkFilterValueSaved('Active') ? Number(this.checkFilterValueSaved('Active')) : 2,
                                            // active: Number(this.checkFilterValueSaved('Active')) !== 0
                                            active: true
                                        },
                                        {
                                            columnName: 'Unscheduled',
                                            column_id: 'Unscheduled',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            value: Number(this.checkFilterValueSaved('Unscheduled')),
                                            active: Number(this.checkFilterValueSaved('Unscheduled')) !== 0
                                        },
                                        {
                                            columnName: 'Tags',
                                            column_id: 'Labels',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.courseListSearchable.labels,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Labels'),
                                            active: this.checkFilterValueSaved('Labels').length > 0
                                        },
                                        {
                                            columnName: 'Companies',
                                            column_id: 'Companies',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.courseListSearchable.companies,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Companies'),
                                            active: this.checkFilterValueSaved('Companies').length > 0
                                        },
                                    ]}
                                />
                            </div>
                        </Grid>
                    </Grid>
                }
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCourseList: Actions.getCourseList,
        updateCourseListLoaded: Actions.updateCourseListLoaded,
        setTableFilter: TableFilterActions.saveTableFilter,
        setTableSort: TableActions.setTableSort,
        // setTableFilter: TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,
        clearFilterStore: TableFilterActions.clearFilterStore
    }, dispatch);
}

function mapStateToProps({ courseApp, tableSort, auth, tableFilter }) {
    return {
        courseList: courseApp.courses.courseList,
        listLoaded: courseApp.courses.listLoaded,
        courseListLoadedAfterSave: courseApp.courses.courseListLoadedAfterSave,
        courseListSearchable: courseApp.courses.courseListSearchable,
        table_sort: tableSort.table_sort,
        table_filter: tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded: tableSort.is_loaded,
        filterList: tableFilter,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseList)));


// WEBPACK FOOTER //
// src/main/content/course/CourseList.js